var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletMobileNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4790_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 21.5C46 27.4677 43.7272 34.4045 40 38.4922C35.7936 43.1053 29.7349 46 23 46C16.0287 46 9.71791 42.8985 5.5 38C2.03238 33.9729 0 28.7312 0 23C0 18.8659 2.09069 13.8525 4 10.5C7.95737 3.55138 14.4315 0.5 23 0.5C29.7349 0.5 35.7936 2.89472 40 7.50784C43.7272 11.5955 46 15.5323 46 21.5Z",
    fill: "#FFD550",
    fillOpacity: 0.16
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 29C31.1046 29 32 28.1046 32 27C32 25.8954 31.1046 25 30 25C28.8954 25 28 25.8954 28 27C28 28.1046 28.8954 29 30 29Z",
    fill: "#191414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17C10 13.6477 12.6477 11 16 11H32C33.6523 11 35 12.3477 35 14V17C35 17.5523 34.5523 18 34 18C33.4477 18 33 17.5523 33 17V14C33 13.4523 32.5477 13 32 13H16C13.7523 13 12 14.7523 12 17V27C12 30.8477 15.1523 34 19 34H32C33.6477 34 35 32.6477 35 31V23.9C35 22.1025 33.5193 20.7479 31.6911 20.8959L17.8002 22.295L17.783 22.2965C16.0149 22.4439 14.5 21.0999 14.5 19.3V18C14.5 16.3477 15.8477 15 17.5 15H29.5C30.0523 15 30.5 15.4477 30.5 16C30.5 16.5523 30.0523 17 29.5 17H17.5C16.9523 17 16.5 17.4523 16.5 18V19.3C16.5 19.8978 16.9813 20.3526 17.6096 20.304L31.4998 18.905L31.517 18.9035C34.4851 18.6561 37 20.9001 37 23.9V31C37 33.7523 34.7523 36 32 36H19C14.0477 36 10 31.9523 10 27V17Z",
    fill: "#191414"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4790_62",
    x: -20,
    y: -19.5,
    width: 86,
    height: 85.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4790_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4790_62",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMobileNav);
export default __webpack_public_path__ + "static/media/wallet_mobile_nav.3fd0e5f6705580a0fae43653649548d8.svg";
export { ForwardRef as ReactComponent };